export const preventDeleteDefaultText = '__DEFAULT__'
